var exports = {
  "M": "x234b8571--235f20--slide",
};

module.exports = exports;
